import ReservationsCalendar from "../calendar/reservations-calendar";

const ReservationCalendar = () => {

  return (
    <ReservationsCalendar />
  );
};

export default ReservationCalendar;
